import { Button } from "@blueprintjs/core"
import StatusIcon from "components/Atoms/StatusIcon"
import { TRANSACTION_STATUS } from "data/static.items"
import {
  TransactionStatus,
  useChangeTransactionStatusMutation,
} from "generated/graphql"
import React from "react"
import { ApolloErrorToast } from "utils/AppToaster"

type EditTransactionStatusType = {
  status?: string
  /**
   * transaction.transactionId (uuid)
   */
  uuid?: string
}
const EditTransactionStatus = ({ status, uuid }: EditTransactionStatusType) => {
  const [update, { loading }] = useChangeTransactionStatusMutation({
    onError: err => {
      ApolloErrorToast(err)
    },
  })
  const statusObj = TRANSACTION_STATUS.find(e => e.id === status)

  function accept() {
    // Can only accept if the transaction is in Created status
    if (statusObj.id === TransactionStatus.CRT) {
      update({
        variables: {
          transactionIds: [uuid],
          // Authorize the transaction
          status: TransactionStatus.AUT,
        },
      })
    }
  }

  function reject() {
    // Can only reject if the transaction is in Crt status
    if (statusObj.id === TransactionStatus.CRT) {
      update({
        variables: {
          transactionIds: [uuid],
          // Reject the transaction
          status: TransactionStatus.FAL,
        },
      })
    }
  }

  // Only able to perform actions when the status is 'Created'
  if (statusObj.id === TransactionStatus.CRT) {
    return (
      <>
        <Button
          loading={loading}
          onClick={accept}
          className="mr-2 rounded-full"
          intent="success"
          icon="tick"
        />
        <Button
          className="rounded-full"
          loading={loading}
          onClick={reject}
          intent="danger"
          icon="cross"
        />
      </>
    )
  }

  return (
    <StatusIcon
      condition={statusObj.id}
      values={{
        [TransactionStatus.AUT]: {
          intent: "success",
          text: "Confirmed",
          tooltip: "Transaction has been confirmed",
        },
        [TransactionStatus.FAL]: {
          intent: "danger",
          text: "Rejected",
          tooltip: "Transaction has been rejected",
        },
        [TransactionStatus.RCF]: {
          intent: "success",
          text: "Confirmed",
          // If the transaction is 'RCF' then it means has been authorized before since
          // CRT -> AUT -> (RCN or RCF)
          tooltip: "Transaction has been confirmed",
        },
        [TransactionStatus.CRT]: {
          intent: "primary",
          text: "Pending",
          tooltip: "Please wait till the transaction is confirmed or rejected",
        },
        [TransactionStatus.RCN]: {
          intent: "success",
          text: "Confirmed",
          // If the transaction is 'RCN' then it means has been authorized before since
          // CRT -> AUT -> (RCN or RCF)
          tooltip: "Transaction has been confirmed",
        },
      }}
    />
  )
}

export default EditTransactionStatus
